/**
 * 创建支付会话请求参数
 * https://confluence.zhihuiya.com/pages/viewpage.action?pageId=262435048
 */
export interface CreatePaymentSessionRequest {
    /**
     * 价格 ID 集合:从Stripe获取
     */
    price_ids: string[];
    /**
     * 支付模式
     */
    mode?: 'subscription';
    /**
     * UI 模式
     * @default 'hosted'
     */
    ui_mode?: 'hosted' | 'custom' | 'embedded';
    /**
     * UI Mode=/custom/embedded时需要
     */
    return_url?: string;
    /**
     * UI Mode=hosted时支付成功跳转地址
     */
    success_url?: string;
    /**
     * UI Mode=hosted时取消支付跳转地址
     */
    cancel_url?: string;
    /**
     * 是否自动计算税费
     * @default false
     */
    automatic_tax?: boolean;
    /**
     * 试用天数 (最大 15 天)
     * @default 7
     */
    trial_days?: number;
}

/**
 * 创建支付会话响应
 */
export interface CreatePaymentSessionResponse {
    /**
     * Stripe 客户 ID
     */
    customer_id: string;
    /**
     * 结账页面 URL
     */
    url: string;
    /**
     * 客户端密钥
     */
    clint_secret: string;
}

/**
 * 订阅项目
 */
export interface SubscriptionItem {
    amount: number;
    concurrency: string;
    current_period_end: string;
    current_period_start: string;
    interval_type: string;
    price_id: string;
    product_name: string;
}

/**
 * 订阅状态枚举
 */
export enum SubscriptionStatus {
    TRIALING = 'trialing',
    ACTIVE = 'active',
    CANCELED = 'canceled',
    ENDED = 'ended',
    PAST_DUE = 'past_due',
    UNPAID = 'unpaid'
}

/**
 * 订阅列表项
 */
export interface SubscriptionListDTO {
    /**
     * 订阅 ID
     */
    subscription_id: string;
    /**
     * 订阅状态
     */
    subscription_status: SubscriptionStatus;
    /**
     * 创建时间
     */
    created_at: string;
    /**
     * 当前周期开始时间
     */
    current_period_start: string;
    /**
     * 当前周期结束时间
     */
    current_period_end: string;
    /**
     * 取消时间，如果有的话，说明在订阅期内取消订阅了
     */
    cancel_at?: string;
    /**
     * 订阅项目列表
     */
    items: SubscriptionItem[];
}

/**
 * Stripe API 服务接口
 * 负责处理 Stripe 支付相关的 API 交互
 */
export interface StripeApi {
    /**
     * 创建支付会话
     * @param request - 支付会话请求参数
     * @returns Promise<CreatePaymentSessionResponse> - 返回支付会话信息
     */
    createPaymentSession(request: CreatePaymentSessionRequest): Promise<CreatePaymentSessionResponse>;

    /**
     * 获取订阅列表
     * @returns Promise<SubscriptionListDTO[]> - 返回订阅列表
     */
    getSubscriptionList(): Promise<SubscriptionListDTO[]>;
}

export const StripeApi = Symbol.for('StripeApi');
